import React, { ReactNode } from 'react';

import { Li, Ol } from './OrderedList.styled';

type TOrderedItems = {
  label: ReactNode;
};

export const OrderedList = ({
  orderedItems,
  margin,
}: {
  orderedItems: TOrderedItems[];
  margin?: string;
}) => {
  return (
    <Ol margin={margin}>
      {orderedItems.map((item: any, index: number) => {
        const { label } = item;

        return <Li key={item + index}>{label}</Li>;
      })}
    </Ol>
  );
};
